import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/terms-section.css'; 

const TermsSection = () => {
  return (
    <div className="terms-section container my-5 p-4 rounded shadow-lg bg-light">
      {/* General Terms */}
      <div className="general-terms mb-5">
        <h2 className="text-primary mb-3">
          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
          الشروط والأحكام العامة
        </h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            يشترط ان يكون صاحب الحساب من منسوبي الجهة
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            ان يكون النشاط والإنجاز يندرج تحت السنة الدراسية الحالية في النظام
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            عدم قبول أي نشاط ما لم يكن له ادلة وشواهد مرفقه
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            جميع الإنجازات التي يتم إيداعها في الحساب الشخصي تخضع للتحكيم لاعتماد الإنجاز من عدمه حسب الشروط المحددة
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            في حالة اكتشاف أي تحايل أو غش أو سرقة من قبل مستخدم النظام سيتم تطبيق اللوائح بحقه
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            يشترط ان تكون المرفقات واضحة من حيث الطباعة والإخراج وتتوافق مع تاريخ النشاط
          </li>
        </ul>
      </div>

      {/* Special Terms */}
      <div className="special-terms">
        <h2 className="text-danger mb-3">
          <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
          الشروط والأحكام الخاصة
        </h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            أن يكون الإنجاز المدرج ضمن محاور ومبادرات الخطة الاستراتيجية بالكليات
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            لا يدخل في الإنجازات الأعمال الروتينية لدى المنسوب او الطالب مثل المحاضرة الصفية والساعة المكتبية و الاجتماعات الدورية في المجالس واللجان المرتبطة بالوظيفة
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            لايدخل في الانجاز المحاضرات العامة والندوات والمؤتمرات التي لا تمنح شهادة حضور
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            يجوز لصاحب الحساب الاستئناف على قرار لجنة التحكيم عند رفض نشاط ما خلال أسبوع من تاريخ القرار وفي حالة رفض لجنة الاستئناف يتم خصم 50 نقطة من الرصيد لكل حالة
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            في حالة قررت لجنة التحكيم رفض نشاط ما فعلى صاحب الحساب تقديم طلب جديد وتلافي ملاحضات اللجنة
          </li>
          <li className="list-group-item">
            <FontAwesomeIcon icon={faExclamationCircle} className="me-2 text-warning" />
            يمنح الصندوق جوائز سنوية نقدية للفائزين في المراكز الخمس الأول
          </li>
        </ul>
      </div>
    </div>
  );
}

export default TermsSection;
